/**
 * This file is part of Magestore POS Open Source.
 *
 * Magestore POS Open Source is free software: you can redistribute it
 * and/or modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation, either version 3
 * of the License, or (at your option) any later version.
 *
 * Magestore POS Open Source is distributed in the hope that it will
 * be useful, but WITHOUT ANY WARRANTY; without even the implied warranty
 * of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along
 * with Magestore POS Open Source. If not, see <https://www.gnu.org/licenses/>
 */ 
import CheckoutAction from "../../../action/CheckoutAction";
import {Observable} from 'rxjs';
import {toast} from "react-toastify";
import i18n from "../../../../config/i18n";
import PaymentService from "../../../../service/payment/PaymentService";
import OrderAction from "../../../action/OrderAction";
import PaymentConstant from "../../../constant/PaymentConstant";
import CreditmemoAction from "../../../action/order/CreditmemoAction";
import EpicFactory from "../../../../framework/factory/EpicFactory";


/**
 *
 * @param result
 * @param action
 * @return {*[]}
 */
const checkoutResult = (result, action) => {
    return [CheckoutAction.processSinglePaymentResult(result, action.payment, action.index)]
};

/**
 *
 * @param result
 * @param action
 * @return {*[]}
 */
const checkoutError = (result, action) => {
    return [CheckoutAction.processSinglePaymentError(result, action.payment, action.index)]
};

/**
 *
 * @param result
 * @param action
 * @return {*[]}
 */
const takePaymentResult = (result, action) => {
    return [OrderAction.processSinglePaymentResult(result, action.payment, action.index)]
};

/**
 *
 * @param result
 * @param action
 * @return {*[]}
 */
const takePaymentError = (result, action) => {
    return [OrderAction.processSinglePaymentError(result, action.payment, action.index)]
};

/**
 *
 * @param result
 * @param action
 * @return {*[]}
 */
const creditmemoResult = (result, action) => {
    return [CreditmemoAction.processSinglePaymentResult(result, action.payment, action.index)]
};

/**
*
* @param result
* @param action
* @return {*[]}
    */
const creditmemoError = (result, action) => {
    return [CreditmemoAction.processSinglePaymentError(result, action.payment, action.index)]
};

/**
 * checkout place order epic
 * @param action$
 * @returns {*}
 */
function ProcessCashPaymentEpic(action$) {
    return action$.ofType(PaymentConstant.START_PROCESS_SINGLE_PAYMENT)
        .mergeMap(action => {
            if (action.payment.method !== PaymentConstant.CASH)
                return Observable.empty();
            return Observable.from(PaymentService.processSinglePayment(
                action.payment,
                action.index,
                action.object
            )).mergeMap((result) => {
                const isCreditmemo   = action.object.isCreditmemo;
                const isCheckoutMode = !action.object.increment_id && !isCreditmemo;

                if (result.error) {
                    toast.error(
                        i18n.translator.translate(result.message),
                        {className: 'wrapper-messages messages-warning'}
                    );

                    if (isCheckoutMode) {
                        return checkoutError(result, action);
                    }

                    if (isCreditmemo) {
                        return creditmemoError(result, action);
                    }

                    return takePaymentError(result, action);
                }

                if (isCheckoutMode) {
                    return checkoutResult(result, action);
                }

                if (isCreditmemo) {
                    return creditmemoResult(result, action);
                }

                return takePaymentResult(result, action);
            }).catch(result => {
                const isCreditmemo   = action.object.isCreditmemo;
                const isCheckoutMode = !action.object.increment_id && !isCreditmemo;

                toast.error(
                    i18n.translator.translate(result.message),
                    {className: 'wrapper-messages messages-warning'}
                );


                if (isCheckoutMode) {
                    return checkoutError(result, action);
                }

                if (isCreditmemo) {
                    return creditmemoError(result, action);
                }

                return takePaymentError(result, action);
            })

        })
}

ProcessCashPaymentEpic.className = 'ProcessCashPaymentEpic';

export default EpicFactory.get(ProcessCashPaymentEpic);



// WEBPACK FOOTER //
// ./src/view/epic/payment/type/CashEpic.js